import { createSlice } from '@reduxjs/toolkit';
import apiClient from '../../api/api_client';
import { loadingSlice } from './loading';

export const defaultDrawingState = {
    drawings: [],
    error: '',
};

// REDUCERS
// basic actions that affect this object only

const getDrawingsReducer = (state, action) => {
    const { drawings = [] } = action.payload;

    return {
        ...state,
        drawings: drawings,
    };
};

const getWinnersReducer = (state, action) => {
    const { drawings = [], requested = {} } = action.payload;

    const updatedDrawings = [...state.drawings];
    updatedDrawings.forEach((draw, index) => {
        // normal response carry on
        if (drawings.length > 0) {
            drawings.forEach(winnersDraw => {
                if (
                    parseInt(winnersDraw.draw_number, 10) ===
                    parseInt(draw.draw_number, 10)
                ) {
                    updatedDrawings[index] = {
                        ...updatedDrawings[index],
                        winners: winnersDraw.winners,
                    };
                }
            });
        } else {
            // this condition seems to be an error from the api
            // the drawing reported that it had winners but then
            // the api response for those winners is empty
            if (
                parseInt(draw.draw_number, 10) ===
                parseInt(requested.draw_number, 10)
            ) {
                updatedDrawings[index] = {
                    ...updatedDrawings[index],
                    winners: [],
                    winnersError: true,
                };
            }
        }
    });

    return {
        ...state,
        drawings: updatedDrawings,
    };
};

const resetReducer = (state, action) => {
    return {
        ...defaultDrawingState,
    };
};

const clearErrorsReducer = (state, action) => {
    return {
        ...state,
        error: '',
    };
};

export const drawingSlice = createSlice({
    name: 'drawings',
    initialState: defaultDrawingState,
    reducers: {
        getDrawings: getDrawingsReducer,
        getWinners: getWinnersReducer,
        reset: resetReducer,
        clearErrors: clearErrorsReducer,
    },
});

//ACTUAL ACTIONS
// a place to make the actions more complex if necessary

const getDrawings = async (dispatch, payload) => {
    dispatch(loadingSlice.actions.setLoading());
    const result = await apiClient.getDrawings();
    dispatch(drawingSlice.actions.getDrawings(result));
    dispatch(loadingSlice.actions.unsetLoading());
};

const getWinners = async (dispatch, payload) => {
    dispatch(loadingSlice.actions.setLoading());
    const result = await apiClient.getWinners(payload);
    dispatch(drawingSlice.actions.getWinners(result));
    dispatch(loadingSlice.actions.unsetLoading());
};

//actions that get exported to the views
export const drawingActions = dispatch => {
    return {
        getDrawings: payload => getDrawings(dispatch, payload),
        getWinners: payload => getWinners(dispatch, payload),
        reset: payload => dispatch(drawingActions.actions.reset(payload)),
        clearErrors: payload => dispatch(drawingActions.actions.clearErrors()),
    };
};
